import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function DeityStrip() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/deities").then((r) => setItems(r.data.items.slice(0, 12))).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section data-testid="home-deity-strip" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="overline">॥ देवी देवता ॥</div>
          <h2 className="font-serif text-3xl md:text-4xl text-[#4A0E17] mt-2">Gods & Goddesses</h2>
        </div>
        <Link to="/deities" data-testid="home-deities-all" className="btn-ghost-gold text-sm">See all →</Link>
      </div>
      <div className="mt-8 flex gap-5 overflow-x-auto pb-4 snap-x">
        {items.map((d) => (
          <Link key={d.slug} to={`/deities/${d.slug}`} data-testid={`home-deity-${d.slug}`} className="snap-start shrink-0 w-32 text-center group">
            <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-[#D4AF37] group-hover:border-[#E65100] transition-sacred">
              <img src={d.image_url} alt={d.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
            </div>
            <div className="font-serif text-[#4A0E17] mt-3 leading-tight text-sm">{d.name}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
